import styled from 'styled-components';
import { color } from './helpers/variables';
import { ImageZoomAnimation } from './helpers/animations';

export const HeroImageContainer = styled.div`
  position: relative;
  width: 100%;
`;

export const HeroImageContent = styled.div`
  display: block;
  width: 100%;
  height: 0;
  padding-bottom: 33.3%;
  margin: 0 auto;
  position: relative;
  overflow: hidden;
`;

export const HeroImageImage = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-image: url("${props => props.url}");
  background-size: cover;
  background-position: center;
  ${ImageZoomAnimation};
`;

export const HeroImageColoredBottom = styled.div`
  position: absolute;
  top: 50%;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: ${props => (props.bgColor ? props.bgColor : color.white)};
`;



// WEBPACK FOOTER //
// ./src/styles/HeroImage.js